<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { __ } from '@oat-sa-private/ui-core';
    import { Button } from '@oat-sa-private/ui-elements';
    import { screenSize } from '../../../../screenSizeStore.js';

    /**
     * @typedef {Object} Props
     * @property {Boolean} [isFinalDelivery]
     * @property {Function} onClose
     * @property {Function} onFinish
     */
    /** @type {Props} */
    // prettier-ignore
    let {
        isFinalDelivery = true,
        onClose,
        onFinish
    } = $props();

    const closeButtonLabel = __('Go back to the question');
    let finishButtonLabel = $derived(isFinalDelivery ? __('Exit test review') : __('Continue to next test'));
    let navButtonSize = $derived($screenSize.mobile ? 'small' : 'medium');
</script>

<style>
    .overview-bottom-bar {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-end;
        align-items: center;
        height: var(--testrunner-footer-height);
        min-height: var(--testrunner-footer-height);
        padding: 0 var(--space-2x);
        gap: 2rem;
    }

    .back-button :global(button) {
        border: none;
    }
</style>

<div class="overview-bottom-bar">
    <span class="back-button">
        <Button
            name="overview-close"
            label={closeButtonLabel}
            ariaLabel={closeButtonLabel}
            icon="revert-16"
            skin="secondary"
            shape="pill"
            size={navButtonSize}
            on:click={onClose} />
    </span>
    <Button
        name="overview-finish"
        label={finishButtonLabel}
        ariaLabel={finishButtonLabel}
        shape="pill"
        size={navButtonSize}
        skin="secondary"
        on:click={onFinish} />
</div>
